import type InsightWorkbenchCartButtonComponent from "adsMagnetoMfc/InsightWorkbenchCartButton";
import React from "react";

import { RemoteComponentWrapper } from "./RemoteComponentWrapper";

const RemoteInsightWorkbenchCartButton = React.lazy(
    () => import("adsMagnetoMfc/InsightWorkbenchCartButton"),
);

type RemoteInsightWorkbenchCartButtonProps = React.ComponentProps<
    typeof InsightWorkbenchCartButtonComponent
>;

export const InsightWorkbenchCartButton: React.FC<
    RemoteInsightWorkbenchCartButtonProps
> = (props) => {
    return (
        <RemoteComponentWrapper>
            <RemoteInsightWorkbenchCartButton {...props} />
        </RemoteComponentWrapper>
    );
};
